module.exports = __webpack_public_path__ + "static/media/6.18_preview.75e01850.png";